import { PageTitleModel, SearchResultHotelsCard } from '../DTOs/hotel.dto';
import { FilterModel } from './filters.model';

// hotel domains will take place here
export interface SearchPayload {
    HotelId?: string;
    StateId?: string;
    CityId?: string;
    CityName?: string;
    CountryName?: string;
    RegionId?: string;
    DistrictId?: string;
    type?: string;
    state_name?: string;
    ReferUrl?: string;
    NoRoom?: string;
    SearchQuery?: string;
    Nights?: string;
    StartDate?: string;
    EndDate?: string;
    Kind?: string;
    Adult?: string;
    Child?: string;
    Room?: string;
    Sort?: string;
    PageIndex: string;
    PageSize: string;
    isFirstRequest: boolean;
    ShabIndex: number;
    // filters ---------------
    maxPrice?: string;
    minPrice?: string;
    labels?: string;
    types?: string;
    grades?: string;
    reviews?: string;
    link?: string;
    typeName?: string;
}
export interface SearchPayloadEcolodge extends SearchPayload {
    // filters ---------------
    hotelTypes?: string;
    hotelStyles?: string;
    facilities?: string;
    labelsAccomodate?: string;
}
export interface SearchResponse {
    Cards: SearchResultHotelsCard[];
    MapUrl: string;
    PageTitle: PageTitleModel;
    ShowBanner: boolean;
    HashKey: string;
    Breadcrumb: object;
    Search: SearchBoxModel;
    OtherHotels: { text: string; url: string }[];
    PageGeneratorLinks: { text: string; url: string }[];
    PopularHotels: { text: string; url: string }[];
    FilterBar: FilterModel[];
    FAQs: SearchResultFaq[];
    state: string;
    ShabIndex: number;
}

export interface SearchBoxModel {
    EndDate: string;
    EndDateGeorgian: string;
    Night: number;
    SearchBox: string;
    StartDate: string;
    StartDateGeorgian: string;
    Id: number;
    Type: number;
    Link: string;
    State: string;
}

export interface SearchResultFaq {
    Title: string;
    Description: string;
}

// ====================================================================
// ====================================================================
// ====== These models are temporary and will change in future ========
// ====================================================================
// ====================================================================

export interface HotelSummaryModel {
    HotelId: number;
    IsActive: boolean;
    SimilarHotelsLink: any;
    Name: string;
    IsFavourite: boolean;
    IsLogin: boolean;
    LowestPriceText: string;
    JsonInfo: string;
    JsonFaq: string;
    NearBies: nearbiesObj;
    NearStreets: any;
    PageGeneratorLinks: { Text: string, Url: string }[]
    Type: number;
    BreadCrumb: BreadCrumb[];
    CityHotels: CityHotels;
    AboutHotel: AboutHotel;
    HouseId: string;
    PersonCapacity: {
        ExtraGuestCount: number;
        FixedGuestCount: number;
    },
    Labels: HotelLabel
    HotelCafe: HotelCafe;
    HotelInternetParking: HotelInternetParking;
    ModalHotelGallery: ModalHotelGallery;
    HotelHeader: HotelHeader;
    LabelHotelReview: any;
    ActivePromotions: any[];
    MetaTags: MetaTags;
    DistanceInfo: DistanceInfo;
    FAQs: Faq[];
    Votes: Vote[];
    Facilities: Facility[];
    Policies: Policies;
    SearchSection: SearchSectionModel;
    ReasonToChoose: any;
    TravelHealth: TravelHealth;
    limitCountNightRange: any;
    ClubOffers: ClubOfferModel[] | null;
    HostInfo: hostInfo;
    AccomodationSpecifications: AccomodationSpecifications[] | undefined;
    ParentId: string;
    Rules: any;
    ShowInstallmentBanner:boolean;
}
export interface hostInfo {
    Image: string;
    Name: string;
    Point: number;
    CountSuccessReserves: number;
    HouseId: string;
    AccomodationsLink: string;
}
export interface AccomodationSpecifications {
    Icon: string;
    Title: string;
    Details: string[];
}
export interface ClubOfferModel {
    Name: string;
    ClubOfferId: number;
}
export interface nearbiesObj {
    HotelId: number;
    NearById: number;
    Name: string;
    Distance: number;
    DistanceUnit: number;
}

export interface TravelHealth {
    Title: string;
    Description: string;
    HotelFacilities: TravelHealthItem[];
}

export interface TravelHealthItem {
    Name: string;
    Description: string;
    IconClassName: string;
}

export interface AddToFavorite {
    message: string;
    result: boolean;
    data: { isFavorite: boolean };
}

export interface SimilarHotelsModel {
    Url: string;
    PictureName: string;
    PictureUrl: string;
    HotelName: string;
    PriceDifference: number;
    HotelGrade: number;
    IsAverage: boolean;
    Score: any | null;
    Price: Price;
    Discount: Discount;
    Star: Star;
    Description: string;
    Address: string;
}

export interface Price {
    StartingText: string;
    OldPrice: boolean;
    BoardPrice: number;
    IhoPrice: number;
    Nights: number;
    AverageIhoPrice: number;
    ClassName: ClassName;
}
export interface ClassName {
    Root: string;
    StartingText: string;
    OldPrice: string;
    NewPrice: string;
    Toman: string;
}
export interface Discount {
    Discount: number;
    Type: string;
    ClassName: string;
}
export interface Star {
    BaseClassName: string;
    HotelRate: boolean;
    StarClassName: string;
    GradeId: number;
}

export interface SearchSectionModel {
    StartDate: string;
    EndDate: string;
    StartDateGeorgian: string;
    EndDateGeorgian: string;
    Night: number;
    SearchBox: string;
}

export interface BreadCrumb {
    Url: string;
    Name: string;
    AriaCurrent: boolean;
}

export interface CityHotels {
    Url: string;
    Count: number;
    Name: string;
}

export interface AboutHotel {
    BriefDescription: string;
    Description: string;
}

export interface HotelCafe {
    Description: string;
}

export interface HotelInternetParking {
    InternetClassName: string;
    InternetTitle: string;
    InternetDescription: string;
    InternetIcon: any;
    ParkingClassName: string;
    ParkingTitle: string;
    ParkingDescription: string;
}

export interface ModalHotelGallery {
    HotelName: string;
    IsFavourite: boolean;
    IsLogin: boolean;
    Star: Star;
    DiscountBalloon: DiscountBalloon;
    Price: Price;
    Pictures: Picture[];
}

export interface Star {
    BaseClassName: string;
    HotelRate: boolean;
    StarClassName: string;
    GradeId: number;
}

export interface DiscountBalloon {
    Discount: number;
    Type: string;
    ClassName: string;
}

export interface Price {
    StartingText: string;
    OldPrice: boolean;
    BoardPrice: number;
    IhoPrice: number;
    Nights: number;
    AverageIhoPrice: number;
    ClassName: ClassName;
}

export interface ClassName {
    Root: string;
    StartingText: string;
    OldPrice: string;
    NewPrice: string;
    Toman: string;
}

export interface Picture {
    Alt: string;
    Jpg: string;
    Webp: string;
    Lazy: boolean;
    ThumbnailUrl: string | null;
}

export interface HotelHeader {
    FullName: string;
    TypeName: string;
    IsFavourite: boolean;
    IsLogin: boolean;
    RoomName: string | null;
    Score: Score;
    Star: Star2;
    Address: Address;
    Labels: Labels;
    Price: Price2;
    Discount: Discount;
    IhoMapUrl: string;
    IhoMapImage: string;
    ForeignName:string;
}

export interface Score {
    ScoreNumber: number;
    Text: string;
    Description: string | null;
    Fill: boolean;
    SolidType: string | null | number;
    Total: number;
    PoorRank: number;
    MiddleRank: number;
    GoodRank: number;
    VeryGoodRank: number;
    ExcellentRank: number;
    PoorRankPercent: number;
    MiddleRankPercent: number;
    GoodRankPercent: number;
    VeryGoodRankPercent: number;
    ExcellentRankPercent: number;
    Url: string;
}

export interface Star2 {
    BaseClassName: string;
    HotelRate: boolean;
    StarClassName: string;
    GradeId: number;
}

export interface Address {
    ClassName: string;
    Address: string;
    CityName: string;
    CityNameEn: string;
    Long: any;
    Lat: any;
    State: string;
}

export interface Labels {
    BaseClassName: string;
    Labels: number[];
}

export interface Price2 {
    StartingText: string;
    OldPrice: boolean;
    BoardPrice: number;
    IhoPrice: number;
    Nights: number;
    AverageIhoPrice: number;
    ClassName: ClassName2;
}

export interface ClassName2 {
    Root: string;
    StartingText: string;
    OldPrice: string;
    NewPrice: string;
    Toman: string;
}

export interface Discount {
    Discount: number;
    Type: string;
    ClassName: string;
}

export interface MetaTags {
    Title: string;
    PageDescription: string;
    Keywords: string;
}

export interface DistanceInfo {
    DistanceList: DistanceList[];
    Airports: any[];
    MetroLines: MetroLine[];
    HolyShrines: any[];
}

export interface DistanceList {
    Name: string;
    Duration: string;
    Distance: string;
}

export interface MetroLine {
    Name: string;
    Distance: number;
    DistanceUnitName: string;
}

export interface Faq {
    Title: string;
    Description: string;
}

export interface Vote {
    HotelId: number;
    Rate: string;
    Title: string;
    Description: string;
    TravelType: number;
    HasOffer: boolean;
    CityName: string;
    HotelAnswer: any;
    HotelAnswerConfirmed: boolean;
    GuestName: string;
    ArrivalDate: string;
    ArrivalDatePersian: string;
    Duration: number;
    TravelTypeTitle: string;
    RateTitle: string;
    RoomName: string;
    AddDate: string;
    AddDatePersian: string;
    AnswerDate: any;
    AnswerDatePersian: string;
    PictureUrl: string;
    TotalRows: number;
    FilterTexts: string[];
}

export interface Facility {
    Id: number;
    Name: string;
    IconClassName: string;
    SvgPic: any;
    Description: any;
    HotelFacilities: HotelFacility[];
}

export interface HotelFacility {
    AskFree: boolean;
    ClassName: string;
    Description: string;
    IconClassName: string;
    Id: number;
    IsFree: boolean;
    Name: string;
    PictureUrl: string;
}

export interface Policies {
    PolicyGroup: PolicyGroup[];
    CheckInTime: string;
    CheckOutTime: string;
    IsHourly: boolean;
    PolicyHotelCancellation: string;
    PolicyHotelChild: string;
    PolicyHotelChecking: string;
    HotelId: number;
}

export interface PolicyGroup {
    Name: string;
    Policies: string[];
}
/*
model gallery rooms
*/

export interface ResposeGalleryRooms {
    modalId: string;
    info: Info;
    slider: Slider[];
}

export interface Info {
    roomId: number;
    description: string;
    roomInfoFacility: RoomInfoFacility;
    price: any;
    roomFacilityCat: RoomFacilityCat[];
}

export interface RoomInfoFacility {
    roomSize: string;
    bedType: string;
    bedSize: string;
    roomName: string;
    extraCapacity: number;
    topRoomFacility: any[];
}

export interface RoomFacilityCat {
    name: string;
    id: number;
    facilities: string[];
}

export interface Slider {
    url: string;
    alt: string;
    width: number;
    height: number;
    thumbnailUrl: string;
}

export interface HotelLabel {
    Tags: { Code: string; Title: string }[]
    Promotions: { Description: string; CountdownTimer: any; Code: HotelLabelEnum; Title: string }[]
}

export enum HotelLabelEnum {
  dynamicLabel = -1,
  exceptional_sales = 1,
  // پیشنهاد آیهو
  iho_offer = 2,
  // شب رایگان
  free_night = 3,
  // لحظه آخری
  last_minute_border = 4,
  // جدید
  new = 5,
  // کنسلی رایگان
  free_cancellation = 7,
  // پیشنهاد آخر هفته
  weekend_offer = 8,
  // پیشنهاد اول هفته
  firstweek_offer = 9,
  // پیش فروش
  presell = 10,
  step_discount = 11,
  mobile_offer = 12,
  // کمترین قیمت
  lowest_price = 13,
  best_price_area = 14,
  best_price_same_hotels = 15,
  best_price_great_hotels = 16,
  best_price_good_hotels = 17,
}
